import React, { useState, useEffect, createContext } from 'react';
import { Fragment } from 'react';
import SEO from './seo';
import Header from './v2/global/Header';
import Footer from './footer';
import AnnouncementBar from './announcement-bar';
import VectorPixel from './vector-pixel';
// import SmallConAnnouncementBar from './smallcon-announcement-bar';


type LayoutProps = {
  title?: string;
  description?: string;
  image?: string;
  children: React.ReactNode;
  hasFooter?: boolean;
  className?: string;
};

export const AnnouncementContext = createContext<boolean>(false);

const Layout = ({
  children,
  title,
  description,
  image,
  hasFooter,
  className,
}: LayoutProps) => {
  const [isAnnouncementVisible, setIsAnnouncementVisible] = useState(false);

  useEffect(() => {
    const isClosed =
      localStorage.getItem('predibase.announcementGuidebook.closed') === 'true';
    setIsAnnouncementVisible(!isClosed && location.pathname !== '/rft');
  }, []);

  const handleClose = () => {
    setIsAnnouncementVisible(false);
    localStorage.setItem('predibase.announcementGuidebook.closed', 'true');
  };

  return (
    <Fragment>
      <SEO title={title} description={description} image={image} />
      <VectorPixel />
      <AnnouncementContext.Provider value={isAnnouncementVisible}>
        <div className="flex flex-col h-full">
          {isAnnouncementVisible && <AnnouncementBar handleClose={handleClose} />}
          <Header
            isAnnouncementVisible={isAnnouncementVisible}
          />
          <main className={`flex-auto ${className || ''} ${isAnnouncementVisible ? 'pt-10' : ''}`}>{children}</main>
          {hasFooter && <Footer />}
        </div>
      </AnnouncementContext.Provider>
    </Fragment>
  );
};

export default Layout;
